
<template>
 <v-container class="py-7 d-flex flex-column align-center justify-center text-center">
    <transition name="fade-up">
      <v-card elevation="0" class="home-card pa-10 transparent-card">
        <v-img
          src="@/assets/logo-123milhas.png"
          contain
          max-width="400"
          class="mx-auto mb-2 fade-item"
        ></v-img>

        <div class="welcome-title mb-2 fade-item">
          {{ userName ? `Olá, ${userName}!` : 'Olá,' }}
        </div>
        
        <div class="welcome-subtitle mb-2 fade-item">
           Bem-vindo ao Painel Administrativo
        </div>

        <div class=" mb-4 fade-item">
          Selecione uma opção no menu lateral para começar.
        </div>
      </v-card>
    </transition>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    userName: null,
  }),
  mounted() {
    if (this.$root.user && this.$root.user.data && this.$root.user.data.name) {
      this.userName = this.$root.user.data.name;
    }
  },
};
</script>

<style scoped>

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

.v-application,
.v-main,
.v-main__wrap {
  height: 100vh !important;
  overflow: hidden !important;
}

.home-card {
  background-color: transparent !important;
  box-shadow: none !important;
}

.welcome-title {
  color: var(--v-primary-base);
  font-size: 36px;
  font-weight: 700;
}

.welcome-subtitle {
  color: var(--v-primary-base);
  font-size: 28px;
}

.fade-up-enter-active {
  animation: fadeUp 0.8s ease-out;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-item {
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;
}
.fade-item:nth-child(1) {
  animation-delay: 0.1s;
}
.fade-item:nth-child(2) {
  animation-delay: 0.3s;
}
.fade-item:nth-child(3) {
  animation-delay: 0.5s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
